import { useState } from "react";

import { compact, isEmpty } from "lodash/fp";

import Typography from "@mui/material/Typography";

import HeaderButton from "@app/analytics/components/reports/HeaderButton";

import { Row } from "@rui/Stack";

import MeetingReportFeedbackSummaryModal, {
  PendingIcon,
} from "./MeetingReportFeedbackSummaryModal";
import useMeetingFeedback from "../hooks/useMeetingFeedback";

const MeetingReportFeedbackSummary = ({
  isMeetingOwner,
}: {
  isMeetingOwner: boolean;
}) => {
  const {
    meetingFeedback: { data: feedback },
  } = useMeetingFeedback({ isMeetingOwner, enabled: true });

  const [modalOpen, setModalOpen] = useState(false);

  // the feedback query is usually much faster than the metrics queries;
  // don't show the feedback summary unless the meeting has also loaded.
  // also for older meetings we may not have a summary available, don't
  // show in that case since they'll all be 0s anyway
  const summaryUnavailable =
    feedback == null || isEmpty(compact(Object.values(feedback)));

  if (summaryUnavailable) return null;

  const toggleModal = () => setModalOpen(!modalOpen);

  return (
    <>
      <HeaderButton
        className="meeting-report__header__feedback"
        onClick={toggleModal}
      >
        <Row variant="center" spacing={2} alignItems="center">
          <Typography variant="bodySecondaryMed">Feedback</Typography>
          <Typography variant="bodyPrimaryMed" sx={{ whiteSpace: "nowrap" }}>
            👍 {feedback.positive}
          </Typography>
          <Typography variant="bodyPrimaryMed" sx={{ whiteSpace: "nowrap" }}>
            👎 {feedback.negative}
          </Typography>
          <Row variant="center">
            <PendingIcon sx={{ mr: 0.5 }} />
            <Typography variant="bodyPrimaryMed">
              {feedback.pending + feedback.skipped}
            </Typography>
          </Row>
        </Row>
      </HeaderButton>
      <MeetingReportFeedbackSummaryModal
        feedback={feedback}
        onClose={toggleModal}
        open={modalOpen}
      />
    </>
  );
};

export default MeetingReportFeedbackSummary;
